/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ConsentEntity,
    ConsentEntityFromJSON,
    ConsentEntityFromJSONTyped,
    ConsentEntityToJSON,
} from './ConsentEntity';
import {
    PersonEntity,
    PersonEntityFromJSON,
    PersonEntityFromJSONTyped,
    PersonEntityToJSON,
} from './PersonEntity';
import {
    ReadConsentOptOutEntity,
    ReadConsentOptOutEntityFromJSON,
    ReadConsentOptOutEntityFromJSONTyped,
    ReadConsentOptOutEntityToJSON,
} from './ReadConsentOptOutEntity';

/**
 * 
 * @export
 * @interface CardTypeConsentEntity
 */
export interface CardTypeConsentEntity {
    /**
     * 
     * @type {string}
     * @memberof CardTypeConsentEntity
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CardTypeConsentEntity
     */
    cardTypeId?: string;
    /**
     * 
     * @type {string}
     * @memberof CardTypeConsentEntity
     */
    exportRestriction?: string;
    /**
     * 
     * @type {string}
     * @memberof CardTypeConsentEntity
     */
    sendPostToCarePrincipal?: string;
    /**
     * 
     * @type {string}
     * @memberof CardTypeConsentEntity
     */
    recurringCard?: string;
    /**
     * 
     * @type {PersonEntity}
     * @memberof CardTypeConsentEntity
     */
    person?: PersonEntity;
    /**
     * 
     * @type {Array<ConsentEntity>}
     * @memberof CardTypeConsentEntity
     */
    consents?: Array<ConsentEntity>;
    /**
     * 
     * @type {ReadConsentOptOutEntity}
     * @memberof CardTypeConsentEntity
     */
    readConsentOptOut?: ReadConsentOptOutEntity;
}

export function CardTypeConsentEntityFromJSON(json: any): CardTypeConsentEntity {
    return CardTypeConsentEntityFromJSONTyped(json, false);
}

export function CardTypeConsentEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): CardTypeConsentEntity {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'cardTypeId': !exists(json, 'cardTypeId') ? undefined : json['cardTypeId'],
        'exportRestriction': !exists(json, 'exportRestriction') ? undefined : json['exportRestriction'],
        'sendPostToCarePrincipal': !exists(json, 'sendPostToCarePrincipal') ? undefined : json['sendPostToCarePrincipal'],
        'recurringCard': !exists(json, 'recurringCard') ? undefined : json['recurringCard'],
        'person': !exists(json, 'person') ? undefined : PersonEntityFromJSON(json['person']),
        'consents': !exists(json, 'consents') ? undefined : ((json['consents'] as Array<any>).map(ConsentEntityFromJSON)),
        'readConsentOptOut': !exists(json, 'readConsentOptOut') ? undefined : ReadConsentOptOutEntityFromJSON(json['readConsentOptOut']),
    };
}

export function CardTypeConsentEntityToJSON(value?: CardTypeConsentEntity | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'cardTypeId': value.cardTypeId,
        'exportRestriction': value.exportRestriction,
        'sendPostToCarePrincipal': value.sendPostToCarePrincipal,
        'recurringCard': value.recurringCard,
        'person': PersonEntityToJSON(value.person),
        'consents': value.consents === undefined ? undefined : ((value.consents as Array<any>).map(ConsentEntityToJSON)),
        'readConsentOptOut': ReadConsentOptOutEntityToJSON(value.readConsentOptOut),
    };
}

